import React from "react";
import { FormValues, FormValuesFilters } from "../types";
import { useCounselors } from "@/hooks/useCounselors";
import { useMajors } from "@/hooks/useMajors";
import { useInterests } from "@/hooks/useInterests";
import { i18n } from "@/i18n";
import { FilterReviewFields } from "../BulkMessageReviewPage/FilterReviewFields";
import { FieldErrors } from "react-hook-form";

export interface FilterDisplayProps {
  filters: FormValuesFilters;
  errors?: FieldErrors<FormValues>;
}

export function FilterDisplay({ filters, errors }: FilterDisplayProps) {
  const { data: counselors, loading: loadingCounselors } = useCounselors();
  const { data: majors, loading: loadingMajors } = useMajors();
  const { data: interests, loading: loadingInterests } = useInterests();

  if (loadingCounselors || loadingMajors || loadingInterests) {
    return i18n.t("global.loading");
  } else {
    return (
      <FilterReviewFields
        filters={filters}
        errors={errors?.filters}
        counselors={counselors || []}
        majors={majors || []}
        interests={interests || []}
      />
    );
  }
}
